
import React from 'react';
import ReactDOM from 'react-dom/client';

import {
    BrowserRouter,
    Routes,
    Route
} from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import Exhibitors from './pages/Exhibitors';
import Bookings from './pages/Bookings';
import FAQ from './pages/FAQ';
import Schedule from './pages/Schedule';
import Content from './pages/Content';
import Settings from './pages/Settings';
import Error404 from './pages/Error404';
import Login from './pages/Login';
import NoAccess from './pages/NoAccess';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

    <BrowserRouter>

        <Routes>

         <Route path="/" element={<Login />} />

<Route path="/dashboard" element={<Dashboard />} />

            <Route path="/exhibitors" element={<Exhibitors />} />

            <Route path="/bookings" element={<Bookings />} />

            <Route path="/faq" element={<FAQ />} />

            <Route path="/schedule" element={<Schedule />} />

            <Route path="/content" element={<Content />} />

            <Route path="/settings" element={<Settings />} />

            <Route path="*" element={<Error404 />} />

            <Route path="/login" element={<Login />} />

<Route path="/noaccess" element={<NoAccess />} />

        </Routes>

    </BrowserRouter>

);